








import {Vue, Component, Prop } from 'vue-property-decorator';

@Component({  })
export default class DefaultWrapper extends Vue {

    @Prop() tailPosition: { x: number; y: number};

    mounted() {
        setTimeout(() => {
            document.addEventListener('click', this.clickOutsideHandler);
            document.addEventListener('keydown', this.escHandler);
        }, 100)
    }

    clickOutsideHandler(event: Event) {
        const el = this.$el as HTMLElement;
        const target = event.target as HTMLElement

        const isClickInside = el.contains(target);

        if(!isClickInside) {
            this.$emit("close")
        }
    }

    escHandler(e: KeyboardEvent) {
        if(e.key === "Escape") {
            this.$emit('close')
        }
    }

    beforeDestroy() {
        document.removeEventListener('click', this.clickOutsideHandler);
        document.removeEventListener('keypress', this.escHandler);
    }
}

